// extracted by mini-css-extract-plugin
export default {"imageWrapper":"mH-z","twoColumnImage":"nH-z"};